exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.list-panel {\n  height: 20vh;\n  overflow: scroll;\n}\n#site-search > .v-input__slot {\n  border-radius: 0px;\n}\n#site-search > .theme--light.v-text-field--outline > .v-input__control > .v-input__slot {\n  margin-bottom: 0px;\n}\n#site-search > .v-text-field.v-text-field--enclosed .v-text-field__details {\n  display: none;\n}\n", ""]);

